export interface LayoutStateInterface {
  hideMobileToolbar: boolean;
}

function state(): LayoutStateInterface {
  return {
    hideMobileToolbar: false,
  }
}

export default state;
